import axios from 'axios';

/** Default terms and conditions document (Novus). */
export const TERMS_PDF_URL = 'https://cdn.simplyask.ai/symphona-cpq/termsAndConditions.pdf';

/**
 * SimplyAsk.ai terms and conditions, shown to TMF tenants. The source file is
 * src/assets/simplyaskTermsAndConditions.pdf and must be published next to the Novus PDF on the CDN.
 */
export const SIMPLYASK_TERMS_PDF_URL = 'https://cdn.simplyask.ai/symphona-cpq/simplyaskTermsAndConditions.pdf';

export const getTermsPdfUrl = (tmfEnabled: boolean): string => (tmfEnabled ? SIMPLYASK_TERMS_PDF_URL : TERMS_PDF_URL);

export const fetchTermsPdf = async (url: string = TERMS_PDF_URL): Promise<Blob> => {
  const { data } = await axios.get<Blob>(url, { responseType: 'blob' });
  return data;
};
